import { render } from "./AppTutorials.vue?vue&type=template&id=c16b1e8e"
import script from "./AppTutorials.vue?vue&type=script&lang=js"
export * from "./AppTutorials.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__